import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { AcceptInvitation, AcceptInvitationParams } from './model';
import { AcceptInvitationView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export function AcceptInvitationRoute (
    model : (params : AcceptInvitationParams) => AcceptInvitation,
    appWrapper : AppWrapper,
    request : Location
) {
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <AcceptInvitationView model={model(inboundParams(request))} />
            </AppWrapperView>
    };
}

function inboundParams(request : Location) : AcceptInvitationParams {
    return {
        invitationId: +(request.params['invitationId'] || 0),
        token: request.params['token'] || ''
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/acceptinvitation/route.tsx